import React, { useState } from "react";
import banner from "../Assets/Images/homebanner.jpg";
import ApiRequest from "../Common/restservice";
import { errorToast, successToast } from "../Common/showtoast";
import { Link, useNavigate } from "react-router-dom";

function ForgotPassword() {
  const navigate = useNavigate();
  const [stateObj, setStateObj] = useState({});

  const OnLogin = async (e) => {
    e.preventDefault();

    if (!stateObj.username) {
      errorToast("Enter valid email", 7000); // ⏳ Show for 7 seconds
      return;
    }

    const jsoninput = {
      username: stateObj.username,
      email: stateObj.username,
    };

    let res = await ApiRequest(
      "resetpassword.asp",
      "POST",
      JSON.stringify(jsoninput)
    );

    if (res.status === "error") {
      errorToast(res.message, 7000); // ⏳ Show for 7 seconds
      return;
    }

    successToast(res.message, 7000); // ⏳ Show for 7 seconds
    navigate("/");
  };

  return (
    <>
      <section>
        <div
          className="bannerimg cover-image bg-background3"
          data-bs-image-src={banner}
          style={{ background: `url(${banner}) center 25%` }}
        >
          <div className="header-text mb-0">
            <div className="container">
              <div className="text-center text-white">
                <h1>Forgot Password</h1>
                <ol className="breadcrumb text-center">
                  <li className="breadcrumb-item">
                    <Link to={"/"}>Home</Link>
                  </li>
                  <li
                    className="breadcrumb-item active text-white"
                    aria-current="page"
                  >
                    Forgot Password
                  </li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="sptb">
        <div className="container customerpage">
          <div className="row">
            <div className="single-page">
              <div className="col-lg-5 col-xl-4 col-md-6 d-block mx-auto">
                <div className="wrapper wrapper2">
                  <form className="card-body" onSubmit={OnLogin}>
                    <h3>Forgot Password</h3>
                    <div className="mail">
                      <input
                        type="text"
                        name="mail"
                        value={stateObj.username || ""}
                        onChange={(e) =>
                          setStateObj({ ...stateObj, username: e.target.value })
                        }
                      />
                      <label>Mail ID</label>
                    </div>
                    <div className="submit">
                      <button
                        className="btn btn-primary btn-block"
                        type="submit"
                      >
                        Get Password
                      </button>
                    </div>
                    <p className="text-dark mb-0">
                      Back to&nbsp;
                      <Link to={"/login"} className="text-primary mx-1">
                        Sign In
                      </Link>
                    </p>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default ForgotPassword;
